<template>
    <button @click.prevent="toggle" class="btn btn-gray p-2 rounded-l-none"><icon type="check-circle" class="block w-6 h-6" /></button>

    <modal v-model="show">
        <h1 class="heading-2">Approve?</h1>

        <div>Are you sure you are ready to approve your job post?</div>

        <div>Once you approve your job post, you will no longer be able to edit your job post and it will go live for 2 months.</div>

        <template #footer="{ close }">
            <div class="flex gap-4">
                <button @click.prevent="close" class="btn btn-gray flex-1">Cancel</button>
                <loading-button @click.prevent="approveJob" :loading="form.processing" class="btn btn-green flex-1">Approved</loading-button>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref } from 'vue'
import useForm from '@/functions/useForm';

const form = useForm({})

const props = defineProps({
    url: {
        type: String,
        default: true,
    }
})

const show = ref(false)

const toggle = () => show.value = !show.value
const approveJob = () => form.post(props.url)
</script>
